import { createAction, props } from '@ngrx/store';
import { ComponentType } from '@angular/cdk/overlay';
import { IUser } from '@shared/user.interface';
/**
 * @USERMANAGEMENT DIALOG ACTIONS
 * */
export const updateEditIrisId = createAction(
  '[User Management] Update Edit Iris Id',
  props<{
    data: Partial<IUser>;
  }>(),
);

export const onUpdateEditIrisIdSuccess = createAction(
  '[User Management] Update Edit Iris Id Success',
  props<{
    data: IUser;
  }>(),
);

export const onUpdateEditIrisIdFailure = createAction(
  '[User Management] Update Edit Iris Id Failure',
  props<{
    error: Error;
  }>(),
);

export const USER_MANAGEMENT_ACTIONS = {
  onUpdateEditIrisIdFailure,
  onUpdateEditIrisIdSuccess,
  updateEditIrisId,
};

/*
 * @DIALOG ACTIONS
 * */
const openUserManagementDialog = createAction(
  '[User Management] Open User Management Dialog',
  props<{
    component: () => ComponentType<unknown>;
    data: unknown;
  }>(),
);

export const USER_MANAGEMENT_DIALOG_ACTIONS = {
  openUserManagementDialog,
};
